import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { RecursoCampanhaSituacaoMultiselectComponent } from './multiselect';
import { RecursoCampanhaSituacaoPipe } from './pipes';
import { RecursoCampanhaSituacaoBadgeComponent } from './badge';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        RecursoCampanhaSituacaoMultiselectComponent,
        RecursoCampanhaSituacaoBadgeComponent,

        // Pipes
        RecursoCampanhaSituacaoPipe
    ],
    exports: [
        RecursoCampanhaSituacaoMultiselectComponent,
        RecursoCampanhaSituacaoBadgeComponent,

        // Pipes
        RecursoCampanhaSituacaoPipe
    ],
    providers: [
        // Pipes
        RecursoCampanhaSituacaoPipe
    ]
})
export class RecursoCampanhaSituacaoModule { }
